<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M9.25577 5.27577L6.25579 6.99006L7 8.29242L10 6.57814L9.25577 5.27577ZM5.5 8.29242V11.7077H7V8.29242H5.5ZM6.25579 13.01L9.25577 14.7243L10 13.4219L7 11.7077L6.25579 13.01ZM10.7442 14.7243L13.7442 13.01L13 11.7077L10 13.4219L10.7442 14.7243ZM14.5 11.7077V8.29242H13V11.7077H14.5ZM13.7442 6.99006L10.7442 5.27577L10 6.57814L13 8.29242L13.7442 6.99006ZM14.5 8.29242C14.5 7.75414 14.2115 7.25712 13.7442 6.99006L13 8.29242H14.5ZM13.7442 13.01C14.2115 12.743 14.5 12.246 14.5 11.7077H13L13.7442 13.01ZM9.25577 14.7243C9.71695 14.9878 10.2831 14.9878 10.7442 14.7243L10 13.4219L9.25577 14.7243ZM5.5 11.7077C5.5 12.246 5.78843 12.743 6.25579 13.01L7 11.7077H5.5ZM6.25579 6.99006C5.78843 7.25712 5.5 7.75414 5.5 8.29242H7L6.25579 6.99006ZM10 6.57814L10.7442 5.27577C10.2831 5.01226 9.71695 5.01226 9.25577 5.27577L10 6.57814ZM13.3779 7.206L9.62792 9.34885L10.3721 10.6512L14.1221 8.5084L13.3779 7.206ZM10.3721 9.34885L6.62211 7.206L5.87789 8.5084L9.62792 10.6512L10.3721 9.34885ZM9.25 10.0001V14.2857H10.75V10.0001H9.25Z"
        class="fill-current"
      />
      <path
        d="M4 3.25C3.58579 3.25 3.25 3.58579 3.25 4C3.25 4.41421 3.58579 4.75 4 4.75V3.25ZM4.0075 4.75C4.42171 4.75 4.7575 4.41421 4.7575 4C4.7575 3.58579 4.42171 3.25 4.0075 3.25V4.75ZM16 3.25C15.5858 3.25 15.25 3.58579 15.25 4C15.25 4.41421 15.5858 4.75 16 4.75V3.25ZM16.0075 4.75C16.4217 4.75 16.7575 4.41421 16.7575 4C16.7575 3.58579 16.4217 3.25 16.0075 3.25V4.75ZM4 15.25C3.58579 15.25 3.25 15.5858 3.25 16C3.25 16.4142 3.58579 16.75 4 16.75V15.25ZM4.0075 16.75C4.42171 16.75 4.7575 16.4142 4.7575 16C4.7575 15.5858 4.42171 15.25 4.0075 15.25V16.75ZM16 15.25C15.5858 15.25 15.25 15.5858 15.25 16C15.25 16.4142 15.5858 16.75 16 16.75V15.25ZM16.0075 16.75C16.4217 16.75 16.7575 16.4142 16.7575 16C16.7575 15.5858 16.4217 15.25 16.0075 15.25V16.75Z"
        class="fill-current"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CubeIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
